import "./PlumbingServices.module.css";
import Header from "@/reusable_sections/Header";
import EmergencyPlumbingHero from "./sections/EmergencyPlumbingHero";
import Valuepropositiongrid from "./sections/Valuepropositiongrid";
import ServicePricing from "./sections/ServicePricing";
import PlumbingDeepDive from "./sections/PlumbingDeepDive";
import MasterPlumbersGrid from "./sections/MasterPlumbersGrid";
import PlumbingTestimonials from "./sections/PlumbingTestimonials";
import PlumbingFAQ from "./sections/PlumbingFAQ";
import ReadyToSchedule from "./sections/ReadyToSchedule";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function PlumbingServicesPage() {
  return <div>
      <Header />
      <EmergencyPlumbingHero />
      <Valuepropositiongrid />
      <ServicePricing />
      <PlumbingDeepDive />
      <MasterPlumbersGrid />
      <PlumbingTestimonials />
      <PlumbingFAQ />
      <ReadyToSchedule />
      <Booking />
      <Footer />
    </div>;
}